import axios from './axios';
import api from './api';
import POINT from './point';
export default {
	install: Vue => {
		// 需要挂载的都放在这里
		Vue.prototype.$point = POINT;
		Vue.prototype.$api = api;
		Vue.prototype.$ajax = axios;
		Vue.prototype.$axios = axios;
	}
};
